export class DemographicGender {
	public key: string
	public name: string

	constructor(keyAndName: string) {
		this.key = keyAndName
		this.name = keyAndName
	}

	// Factory method for creating from string
	static create(keyAndName: string): DemographicGender {
		return new DemographicGender(keyAndName)
	}
}
